import { themeAtom } from '@src/store/theme/theme';
import { useAtomValue } from 'jotai';
import type { FC } from 'react';
import { memo } from 'react';
import { Tweet } from 'react-tweet';

interface TwitterEmbedProps {
    embed: string;
    caption?: string;
    className?: string;
}

const TwitterEmbed: FC<TwitterEmbedProps> = props => {
    const { className, embed, caption } = props;
    const { isDarkModeOn } = useAtomValue(themeAtom);

    // Extract tweet ID from the embed URL
    function getTweetIdFromUrl(url: string): string {
        const parts = url.split('id=');
        return parts.length > 1 ? (parts[1] ?? '') : '';
    }

    const tweetId = getTweetIdFromUrl(embed);

    function renderCaption() {
        if (!caption) return null;

        return <p className="text-sm text-gray-500">{caption}</p>;
    }

    if (!tweetId) {
        return null;
    }

    return (
        <div className={className} data-theme={isDarkModeOn ? 'dark' : 'light'}>
            <div className="flex items-center justify-center">
                <Tweet id={tweetId} />
            </div>
            {renderCaption()}
        </div>
    );
};

export default memo(TwitterEmbed);
